module.exports = __webpack_public_path__ + "img/Picture8.b4b93892.jpg";